var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIndicator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#EDD5D0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7188 24C12.7188 17.7868 17.7555 12.75 23.9688 12.75C30.182 12.75 35.2188 17.7868 35.2188 24C35.2188 30.2132 30.182 35.25 23.9688 35.25C17.7555 35.25 12.7188 30.2132 12.7188 24ZM23.9688 11.25C16.9271 11.25 11.2188 16.9584 11.2188 24C11.2188 31.0416 16.9271 36.75 23.9688 36.75C31.0104 36.75 36.7188 31.0416 36.7188 24C36.7188 16.9584 31.0104 11.25 23.9688 11.25ZM24.7188 20C24.7188 19.5858 24.383 19.25 23.9688 19.25C23.5545 19.25 23.2188 19.5858 23.2188 20V25C23.2188 25.4142 23.5545 25.75 23.9688 25.75C24.383 25.75 24.7188 25.4142 24.7188 25V20ZM23.9688 28.25C23.5545 28.25 23.2188 28.5858 23.2188 29V29.01C23.2188 29.4242 23.5545 29.76 23.9688 29.76H23.9787C24.393 29.76 24.7287 29.4242 24.7287 29.01V29C24.7287 28.5858 24.393 28.25 23.9787 28.25H23.9688Z",
    fill: "#A72E12"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndicator);
export default __webpack_public_path__ + "static/media/indicator.71ea85a804aeb098223516a293cb509f.svg";
export { ForwardRef as ReactComponent };